import React from 'react';
import { steps } from '../data/finanza';
export function HowItWorks() {
  return <section className="w-full border-y border-[#1E2B58]/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-177" data-mp="7svdaescvutl">
      <div className="mx-auto max-w-6xl" data-id="element-178" data-mp="3pyrp50ha6wc5">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-179" data-mp="3pzt8rtcd4r5h">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl lg:col-span-7" data-id="element-180" data-mp="3tzjydtq5l18f">
            Come funziona <em className="text-[#1F9D6B]" data-id="element-181" data-mp="lkthqcb4h2jf">FINANZA PRONTA™</em>
          </h2>
          <p className="text-lg leading-relaxed text-[#1E2B58]/75 lg:col-span-5" data-id="element-182" data-mp="qibgxazc83e8">
            Dal download all'aula: scegli la lezione e prepari tutto in pochi minuti.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-183" data-mp="gsi6weeufwc3">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-[#1E2B58] pt-6" data-id="element-184" data-mp="14icjcuv93ivt" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-[#1F9D6B]" aria-hidden="true" data-id="element-185" data-mp="19aw7glrkdwev">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-[#1E2B58]" data-id="element-186" data-mp="2rjbm5hh6d8t9">
                <span className="sr-only" data-id="element-187" data-mp="2mki5xhai73pe">Passo {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-[#1E2B58]/70" data-id="element-188" data-mp="2wkr3ozk58x6w">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-[#1E2B58]/80 sm:text-3xl" data-id="element-189" data-mp="3abvy9n8nmzad">
          Apri → scegli → stampa → entra in aula. Semplice e strutturato.
        </p>
      </div>
    </section>;
}